import React, { useState } from 'react'
import './Header.scss'
import { useSelector, useDispatch } from 'react-redux';
import { selectTopTab, loggingOut, rightBarClicked } from '../redux/actions/index';
import { Link } from "react-router-dom"
import { ReactComponent as RendiIcon } from "../assets/svg/mainLogo/rendiLogoSmall.svg";
import { ReactComponent as MessageIcon } from "../assets/svg/menu1/message.svg";
import { ReactComponent as InformationIcon } from "../assets/svg/menu1/information.svg";
import { ReactComponent as UserIcon } from "../assets/svg/menu1/user.svg";

function Header() {
  const topTapData = useSelector(state => state.topTab)
  const [menuOneNum, setMenuOneNum] = useState(0);
  const [menuTwoNum, setMenuTwoNum] = useState(0);
  const dispatch = useDispatch()
  const selectTopTaB = (id) => {
    dispatch(selectTopTab(id));
  }
  const loggingOuT = () => {
    dispatch(loggingOut());
  }
  const rightBarClickeD = () => {
    dispatch(rightBarClicked());
  }

  const linkTo = (id) => {
    switch (id) {
      case 1: return '/program'
      case 2: return '/report'
      default : return '/repertoire'
    }
  }

  return (
    <div className='Header'>
      <div className='header-top'>
        <RendiIcon />
        <div className='right-btns'>
          <div className='top-btn' onClick={rightBarClickeD}>
            <MessageIcon />
            <p>AZIONI</p>
          </div>
          <div className='top-btn' onClick={() => { setMenuOneNum(2) }} onMouseLeave={() => { setMenuOneNum(0) }}>
            <InformationIcon />
            <p>INFO</p>
            <div className={menuOneNum === 2 ? 'sub-menu' : 'sub-menu hidden'}>
              <p>ASSISTENZA</p>
              <p>LISTINI</p>
              <p>TUTORIAL</p>
              <p>CREDITS & PRIVACY</p>
            </div>
          </div>
          <div className='top-btn' onClick={() => { setMenuOneNum(3) }} onMouseLeave={() => { setMenuOneNum(0) }}>
            <UserIcon />
            <p>ACCOUNT</p>
            <div className={menuOneNum === 3 ? 'sub-menu' : 'sub-menu hidden'}>
              <p>OPZIONI UTENTE</p>
              <p>GESTIONE UTENTI</p>
              <Link to='/' className='Linking'>
                <p onClick={loggingOuT}>LOGOUT</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='header-bottom'>
        {
          topTapData.items.map((item, index) => {
            return (
              <Link to={linkTo(index)} className='Linking'  key={'topTapKey' + item.id}>
                <div className='selection-item'
                  onMouseOver={() => { setMenuTwoNum(item.id) }}
                  onMouseLeave={() => { setMenuTwoNum(0) }}
                  onClick={() => {
                    selectTopTaB(item.id)
                  }}>
                  <div className="icon-title">
                    {item.icon}
                    <p className={item.id === topTapData.nowId ? '' : 'hidden'} >{item.name}</p>
                  </div>
                  <div className={item.id === topTapData.nowId ? 'underline' : ''}></div>
                  <div className={menuTwoNum === item.id ? 'itemHover' : 'itemHover hidden'}>{item.name}</div>
                </div>
              </Link>
            )
          })
        }
      </div>
    </div>
  )
}

export default Header